import { MathJaxContext } from "better-react-mathjax";
import loglevel from "loglevel";
import mathJaxUrl from "mathjax-full/es5/tex-svg.js?url";

const log = loglevel.getLogger("MathJax");

export const AppMathJaxProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <MathJaxContext
    src={mathJaxUrl}
    onError={log.error}
    config={{
      SVG: {},
      options: {
        enableMenu: false,
      },
    }}
  >
    {children}
  </MathJaxContext>
);
